import * as types from './mutation-types'

export default {
    [types.CONFIGURATION_UPDATED](state, configuration) {
        state.data = configuration;
    },
    [types.APPLICATION_SELECTED](state, selectedCustomerApplicationId) {
        state.selectedCustomerApplicationId = selectedCustomerApplicationId;
        localStorage.setItem('lastUsedCustomerApplicationId', selectedCustomerApplicationId);
    }
}
